import { EventBus } from '@/utils/event-bus';
import { default as HTTP, requestCanceller } from '@/utils/http';
import i18n from '@/locales';

const defaultState = () => ({
  /** @type {import('@/store/modules/users/models/UserSummary').TUserSummary} */
  user: null,
});

const userModule = {
  namespaced: true,
  state: defaultState(),
  mutations: {
    RESET_STATE(state) {
      Object.assign(state, defaultState());
    },
    SET(state, { updated }) {
      const fullName = updated.name ? updated.name.split(' ') : [];
      state.user = {
        ...updated,
        firstName: fullName.shift(),
        lastName: fullName.join(' '),
      };
      i18n.locale = updated.language;
    },
  },
  actions: {
    RESET_STATE({ commit }) {
      commit('RESET_STATE');
    },
    GET({ commit }) {
      return HTTP({
        method: 'get',
        url: 'users/current',
      }).then((response) => {
        commit('SET', { updated: response.data.data });
      });
    },
    UPDATE({ commit }, user) {
      return HTTP({
        method: 'put',
        url: 'users/current',
        data: user,
      }).then((response) => {
        commit('SET', { updated: response.data.data });
      });
    },
    FORGOT_PASSWORD(state, { email }) {
      return HTTP({
        method: 'post',
        url: 'forgot-password',
        auth: false,
        meta: {
          authorized: false,
          type: 'forgot-password',
        },
        data: {
          email,
        },
        cancelToken: requestCanceller.getToken(true), // reset cancel token
      }).then(response => response);
    },
    /* eslint-disable camelcase */
    RESET_PASSWORD(state, {
      email, password, resetToken,
    }) {
      return HTTP({
        method: 'post',
        url: `forgot-password/${resetToken}`,
        meta: {
          type: 'reset-password',
        },
        data: {
          email,
          password,
          resetToken,
        },
      }).then(response => response);
    },
    /* eslint-enable camelcase */
    REGISTER({ dispatch }, reg) {
      return HTTP({
        method: 'post',
        url: 'company',
        auth: false,
        meta: {
          type: 'register',
        },
        suppressAllErrors: true,
        data: reg,
      }).then(() => {
        EventBus.$emit('renderGlobalMessage', ({
          message: i18n.t('register.accountCreated'),
          icon: 'check',
          type: 'success',
        }));
        return dispatch('auth/LOGIN', { email: reg.email, password: reg.password }, { root: true }).then(() => {
          dispatch('company/GET', null, { root: true });
          dispatch('plan/GET', {}, { root: true });
        });
      }).catch((error) => {
        throw error.response.data;
      });
    },
  },
  getters: {
    /** @param {ReturnType<defaultState>} state */
    user: state => state.user,
    team: state => (state.user ? state.user.team : null),
  },
};

export default userModule;

/** @typedef {RefRT<typeof userModule.getters>} TUserGetters */
